/* Cart Drawer Pro extras - ABCD Fashion.
   Oct 23 2026: the free T-shirt is switched off (OlyxFixesConfig.giftShop 0, no gift product in the
   drawer settings). The bar now has two goals, free shipping and a free shoe, and the drawer shows a
   shipping line under the total so the price never jumps at checkout.
   Three-stage milestone (free T-shirt, free shipping, free shoe) plus a small
   always-on shipping-protection toggle.

   Oct 2026 offer ladder: the free T-shirt unlocks at 150, shipping is free from
   200 and from 400 the shopper picks a free shoe (a UGG or New Balance priced
   100 to 150). Checkout charges shipping below 200 (delivery rate
   "Standaard verzending" up to 199.99, "Gratis verzending" from 200), the
   automatic discount "Free gift over 150" gives the T-shirt and "Free shoe over
   400" gives the cheapest eligible shoe. The shoe discount takes the same items
   as the T-shirt discount, so once a free shoe applies the T-shirt turns into
   a paid line and cdp-cart.js drops it (the shoe replaces the tee).
   All numbers come from OlyxFixesConfig (snippets/olyx-fixes.liquid), converted
   to the visitor's currency, so the drawer never promises more than checkout gives.
   Runs alongside cdp-cart.js and listens to the cdp:updated event it fires.
   Loaded BEFORE cdp-cart.js so the listener is attached before the first render. */
(function () {
  'use strict';

  var root = document.getElementById('CartDrawerPro');
  if (!root || root.dataset.cdpExtras) return;
  root.dataset.cdpExtras = '1';

  function readJSON(id, fallback) {
    var el = document.getElementById(id);
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
  }

  var X = readJSON('CartDrawerProExtras', {});
  /* real free-shipping threshold in the visitor's currency, in cents.
     Read on every paint: the page config may load after this file. */
  function shipMin() {
    var cfg = window.OlyxFixesConfig;
    if (cfg && cfg.freeShippingExact) return Math.round(cfg.freeShippingExact * 100);
    var rate = 1;
    try { rate = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1; } catch (e) {}
    return Math.round(20000 * rate); /* 200 EUR, same as the free-shipping rate minimum */
  }
  function shipShownCents() {
    var c = window.OlyxFixesConfig;
    return (c && c.freeShipping) ? Math.round(c.freeShipping * 100) : shipMin();
  }
  /* free-gift threshold in the visitor's currency (cents); see snippets/olyx-fixes.liquid */
  function giftMin() {
    var c = window.OlyxFixesConfig;
    if (c && c.giftShop === 0) return 0; /* free T-shirt switched off (Oct 23) */
    if (c && c.giftExact) return Math.round(c.giftExact * 100);
    var rate = 1;
    try { rate = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1; } catch (e) {}
    return Math.round(15000 * rate);
  }
  function giftShownCents() {
    var c = window.OlyxFixesConfig;
    return (c && c.giftShown) ? Math.round(c.giftShown * 100) : giftMin();
  }
  /* shipping fee below the free-shipping threshold, in cents of the visitor's currency */
  function shipFeeCents() {
    var c = window.OlyxFixesConfig;
    if (c && c.shipFeeExact) return Math.round(c.shipFeeExact * 100);
    var rate = 1;
    try { rate = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1; } catch (e) {}
    return Math.round(295 * rate);
  }
  /* free-shoe threshold (cents); 0 means the shoe tier is switched off */
  function shoeMin() {
    var c = window.OlyxFixesConfig;
    return (c && c.shoeExact) ? Math.round(c.shoeExact * 100) : 0;
  }
  function shoeShownCents() {
    var c = window.OlyxFixesConfig;
    return (c && c.shoeShown) ? Math.round(c.shoeShown * 100) : shoeMin();
  }
  /* price band of the shoes that can be free, in cents of the visitor's currency */
  function shoeBand() {
    var c = window.OlyxFixesConfig || {};
    var rate = 1;
    try { rate = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1; } catch (e) {}
    return {
      min: Math.round((c.shoeMinExact || 100 * rate) * 100) - 1,
      max: Math.round((c.shoeMaxExact || 150 * rate) * 100) + 1
    };
  }
  var PROT_VID = Number(X.protectionVariantId) || 0;
  var PROT_PRICE = Number(X.protectionPrice) || 0;
  var GIFT_VID = Number(X.giftVariantId) || 0;
  var FMT = X.moneyFormat || '{{amount_with_comma_separator}}';

  var RE_THOUSANDS = new RegExp('([0-9])(?=([0-9][0-9][0-9])+(?![0-9]))', 'g');
  var RE_PLACEHOLDER = new RegExp('[{][{][ ]*([a-z_]+)[ ]*[}][}]', 'g');

  function money(cents) {
    cents = Number(cents) || 0;
    function num(v, p, t, d) {
      var parts = (v / 100).toFixed(p).split('.');
      var whole = parts[0].replace(RE_THOUSANDS, '$1' + t);
      return p ? whole + d + parts[1] : whole;
    }
    return FMT.replace(RE_PLACEHOLDER, function (m, key) {
      switch (key) {
        case 'amount': return num(cents, 2, ',', '.');
        case 'amount_no_decimals': return num(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return num(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(cents, 0, '.', ',');
        case 'amount_with_space_separator': return num(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return num(cents, 0, ' ', ',');
        default: return num(cents, 2, ',', '.');
      }
    });
  }

  var $ = function (sel) { return root.querySelector(sel); };
  var ms = $('[data-cdp-ms]');
  var msText = $('[data-cdp-ms-text]');
  var msFill = $('[data-cdp-ms-fill]');
  var msShip = $('[data-cdp-ms-ship]');
  var msGift = $('[data-cdp-ms-gift]');
  var msShoe = $('[data-cdp-ms-shoe]');
  var markGift = $('[data-cdp-ms-mark-gift]');
  var markShip = $('[data-cdp-ms-mark-ship]');
  var markShoe = $('[data-cdp-ms-mark-shoe]');
  var shoeBox = $('[data-cdp-shoe]');
  var shoeTitle = $('[data-cdp-shoe-title]');
  var shoeText = $('[data-cdp-shoe-text]');
  var shoeLinks = $('[data-cdp-shoe-links]');
  var shipLine = $('[data-cdp-shipline]');
  var saving = $('[data-cdp-saving]');
  var prot = $('[data-cdp-prot]');
  var protSw = $('[data-cdp-prot-sw]');
  var protPrice = $('[data-cdp-prot-price]');

  function isProt(i) { return !!PROT_VID && Number(i.variant_id) === PROT_VID; }
  var GIFT_HANDLE = X.giftHandle || '';
  function isGift(i) {
    if (!(i.properties && i.properties._olyx_gift)) return false;
    return (!!GIFT_HANDLE && i.handle === GIFT_HANDLE) || (!!GIFT_VID && Number(i.variant_id) === GIFT_VID);
  }

  function merchandiseSubtotal(cart) {
    return (cart.items || []).reduce(function (n, i) {
      return n + (isProt(i) || isGift(i) ? 0 : i.final_line_price);
    }, 0);
  }
  function realCount(cart) {
    return (cart.items || []).reduce(function (n, i) {
      return n + (isProt(i) || isGift(i) ? 0 : i.quantity);
    }, 0);
  }
  function setDeclined(v) {
    try {
      if (v) { sessionStorage.setItem('cdp_protect_off', '1'); }
      else { sessionStorage.removeItem('cdp_protect_off'); }
    } catch (e) {}
  }

  var RE_AMP = new RegExp('&', 'g');
  var RE_LT = new RegExp('<', 'g');
  var RE_GT = new RegExp('>', 'g');
  function esc(t) {
    return String(t == null ? '' : t)
      .replace(RE_AMP, '&amp;').replace(RE_LT, '&lt;').replace(RE_GT, '&gt;');
  }

  /* only <b> is allowed back in after escaping, so the texts can bold one word */
  var RE_B_OPEN = new RegExp('&lt;b&gt;', 'g');
  var RE_B_CLOSE = new RegExp('&lt;/b&gt;', 'g');
  function rich(t) {
    return esc(t).replace(RE_B_OPEN, '<b>').replace(RE_B_CLOSE, '</b>');
  }
  /* "T-shirt \u00b7 EUR 150" on the chips under the bar */
  function setLegend(el, label, cents) {
    if (!el) return;
    var val = money(cents).replace(/[.,]00(?!\d)/, '');
    var amt = el.querySelector('[data-cdp-amt]');
    if (amt) { if (amt.textContent !== val) amt.textContent = val; return; }
    /* older markup: label and amount live in one text node */
    var node = el.lastChild;
    while (node && node.nodeType !== 3) node = node.previousSibling;
    var txt = label + ' \u00b7 ' + val;
    if (node && node.nodeValue.trim() !== txt) node.nodeValue = ' ' + txt;
  }

  var RE_SHOE_TYPE = /^(sneakers?|boots?|slippers?|clogs?|sandals?)$/i;
  var RE_FREE_SHOE = /free shoe/i;

  /* Is a free shoe applied right now, and how much has been spent on paid shoes?
     The free-shoe discount reserves paid shoes worth SHOE_MIN as its "buy" side
     and gives the NEXT eligible pair (UGG or New Balance, 100 to 150) away.
     Cart lines carry product-level discounts (the free shoe is one); the bundle
     percentage is a cart-level discount and is not part of the lines. */
  function shoeState(cart) {
    var applied = null;
    var spend = 0;
    (cart.items || []).forEach(function (i) {
      if (isProt(i) || isGift(i)) return;
      var allocs = i.line_level_discount_allocations || [];
      for (var k = 0; k < allocs.length; k++) {
        var app = allocs[k].discount_application;
        if (app && RE_FREE_SHOE.test(String(app.title || '')) && Number(allocs[k].amount) > 0) applied = i;
      }
      if (RE_SHOE_TYPE.test(String(i.product_type || '').trim())) spend += Number(i.final_line_price) || 0;
    });
    return { applied: applied, spend: spend };
  }

  function paint(cart) {
    if (!cart) return;
    var sub = merchandiseSubtotal(cart);
    var n = realCount(cart);
    var SHIP_MIN = shipMin();
    var GIFT_MIN = giftMin();
    var SHOE_MIN = shoeMin();
    /* the bar runs to the biggest goal; the others sit on the way */
    var TOP = Math.max(SHIP_MIN, GIFT_MIN, SHOE_MIN);
    setLegend(msGift, X.giftLabel || 'T-shirt', giftShownCents());
    setLegend(msShip, X.shipLabel || 'Shipping', shipShownCents());
    if (SHOE_MIN) setLegend(msShoe, X.shoeLabel || 'Shoes', shoeShownCents());

    var hasGift = GIFT_MIN > 0;
    var net = Number(cart.total_price) || sub; /* what the shipping rate looks at: after discounts */
    var shipOk = net >= SHIP_MIN;

    /* free shoe: applied, still short of the shoe spend, or ready to be chosen */
    var st = SHOE_MIN ? shoeState(cart) : { applied: null, spend: 0 };
    var shoeGap = (SHOE_MIN && !st.applied) ? Math.max(0, SHOE_MIN - st.spend) : 0;
    var shoeOn = !!SHOE_MIN && n > 0 && (!!st.applied || shoeGap <= 0);

    if (ms) {
      ms.hidden = n === 0;
      var pct = TOP > 0 ? Math.round((sub / TOP) * 100) : 100;
      pct = Math.max(0, Math.min(100, pct));
      if (msFill) msFill.style.width = pct + '%';
      if (markGift) { markGift.hidden = !hasGift; markGift.style.left = (TOP > 0 ? Math.min(100, (GIFT_MIN / TOP) * 100) : 0) + '%'; }
      if (msGift) msGift.hidden = !hasGift;
      if (markShip) markShip.style.left = (TOP > 0 ? Math.min(100, (SHIP_MIN / TOP) * 100) : 100) + '%';
      if (markShoe) { markShoe.hidden = !SHOE_MIN; markShoe.style.left = '100%'; }
      if (msShoe) msShoe.hidden = !SHOE_MIN;
      if (msText) {
        var txt;
        if (SHOE_MIN && st.applied) {
          txt = rich(X.textShoeOn || 'Free shipping and your free shoes unlocked');
        } else if (SHOE_MIN && shoeOn) {
          txt = rich(X.textShoe || 'Free shipping unlocked! Choose your free shoes');
        } else if (SHOE_MIN && shipOk) {
          txt = rich(X.textShip || 'Free shipping unlocked! Add [amount] more of shoes for a free pair')
            .replace('[amount]', '<b>' + money(Math.max(shoeGap, 0)) + '</b>');
        } else if (hasGift && sub >= GIFT_MIN && shipOk) {
          txt = rich(X.textGift || 'Free T-shirt and free shipping unlocked');
        } else if (hasGift && sub >= GIFT_MIN) {
          txt = rich(X.textMid || 'Free T-shirt unlocked! Add [amount] more for free shipping')
            .replace('[amount]', '<b>' + money(SHIP_MIN - net) + '</b>');
        } else if (hasGift) {
          txt = rich(X.textBelow || 'Add [amount] more for your free T-shirt')
            .replace('[amount]', '<b>' + money(GIFT_MIN - sub) + '</b>');
        } else {
          txt = rich(X.textShipFirst || 'Add [amount] more for free shipping')
            .replace('[amount]', '<b>' + money(Math.max(SHIP_MIN - net, 0)) + '</b>');
        }
        msText.innerHTML = txt;
      }
      if (msShip) msShip.classList.toggle('is-on', shipOk);
      if (msGift) { msGift.classList.toggle('is-on', hasGift && sub >= GIFT_MIN && !shoeOn); msGift.classList.toggle('is-swapped', hasGift && sub >= GIFT_MIN && shoeOn); }
      if (msShoe) msShoe.classList.toggle('is-on', shoeOn);
      if (markShip) markShip.classList.toggle('is-on', shipOk);
      if (markGift) { markGift.classList.toggle('is-on', hasGift && sub >= GIFT_MIN && !shoeOn); markGift.classList.toggle('is-swapped', hasGift && sub >= GIFT_MIN && shoeOn); }
      if (markShoe) markShoe.classList.toggle('is-on', shoeOn);
    }

    /* the "choose your free shoes" block */
    if (shoeBox) {
      var showBox = !!SHOE_MIN && n > 0 && (!!st.applied || shoeGap <= 0);
      shoeBox.hidden = !showBox;
      if (showBox) {
        var band = shoeBand();
        var fill = function (t) {
          return String(t || '').replace('[min]', money(band.min + 1).replace(/[.,]00(?!\d)/, ''))
            .replace('[max]', money(band.max - 1).replace(/[.,]00(?!\d)/, ''));
        };
        shoeBox.classList.toggle('is-done', !!st.applied);
        if (st.applied) {
          if (shoeTitle) shoeTitle.textContent = X.shoeDone || 'Your free shoes are in your cart';
          if (shoeText) shoeText.textContent = '';
          if (shoeLinks) shoeLinks.hidden = true;
        } else {
          if (shoeTitle) shoeTitle.textContent = X.shoeTitle || 'Choose your free shoes';
          if (shoeText) shoeText.textContent = fill(X.shoeText || 'Add a UGG or New Balance from [min] to [max]. The cheapest pair is free, one pair per order.');
          if (shoeLinks) shoeLinks.hidden = false;
        }
        if (shoeText) shoeText.hidden = !shoeText.textContent && !shoeText.innerHTML;
      }
    }

    /* shipping line under the total, so the price never jumps at checkout */
    if (shipLine) {
      if (n > 0 && SHIP_MIN) {
        shipLine.textContent = shipOk
          ? (X.shipFree || 'Shipping: free')
          : (X.shipFee || 'Shipping [fee] \u00b7 free from [min]')
              .replace('[fee]', money(shipFeeCents()))
              .replace('[min]', money(SHIP_MIN).replace(/[.,]00(?!\d)/, ''));
        shipLine.classList.toggle('is-free', shipOk);
        shipLine.hidden = false;
      } else {
        shipLine.hidden = true;
      }
    }

    /* "You save EUR x" under the total: real line discounts (bundle 5% / 10%, free shoe) */
    if (saving) {
      var saved = Number(cart.total_discount) || 0;
      if (saved > 0 && n > 0) {
        saving.textContent = (X.savingText || 'You save [amount]').replace('[amount]', money(saved));
        saving.hidden = false;
      } else {
        saving.hidden = true;
      }
    }

    if (prot && PROT_VID) {
      prot.hidden = n === 0;
      var on = (cart.items || []).some(isProt);
      prot.classList.toggle('is-on', on);
      if (protSw) protSw.setAttribute('aria-checked', on ? 'true' : 'false');
      if (protPrice) protPrice.textContent = money(PROT_PRICE);
    }
  }

  document.addEventListener('cdp:updated', function (e) {
    paint(e && e.detail && e.detail.cart);
  });

  function post(url, payload) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); });
  }

  function finish() {
    if (prot) prot.classList.remove('is-busy');
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  if (protSw) {
    protSw.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (!PROT_VID || !prot || prot.classList.contains('is-busy')) return;
      var on = protSw.getAttribute('aria-checked') === 'true';
      prot.classList.add('is-busy');
      prot.classList.toggle('is-on', !on);
      protSw.setAttribute('aria-checked', on ? 'false' : 'true');

      if (on) {
        setDeclined(true);
        fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            var line = (c.items || []).filter(isProt)[0];
            if (!line) return null;
            return post('/cart/change.js', { id: line.key, quantity: 0 });
          })
          .then(finish, finish);
      } else {
        setDeclined(false);
        post('/cart/add.js', { items: [{ id: PROT_VID, quantity: 1 }] }).then(finish, finish);
      }
    });
  }

  paint(readJSON('CartDrawerProCart', null));
})();
